export default "__VITE_ASSET__rFdpRjKT__"